import { TYPES } from "./default_client.type";
import { onSnapshot, query, where, getDocs, doc } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { getApiFunctions } from "store/user/api";
import { getApp } from "firebase/app";
import { PROJECT_ID } from "config/keys/user";

const app = getApp(PROJECT_ID);
const auth = getAuth(app);

// ========= firebase function =========//
export const addDefaultClient =
  ({ id, clients, note }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().reseller.addClient;
    const options = { id, clients, note };

    console.log({ options });

    functions(options)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Some errors happened!",
          });
        }
      });
  };

export const updateDefaultClient =
  ({ id, clients }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().reseller.updateClient;
    const options = { id, clients };

    functions(options)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Some errors happened!",
          });
        }
      });
  };

//delete multiple
export const deleteDefaultClient =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().reseller.deleteClient;
    const options = { id };

    functions(options)
      .then(() => {
        if (callback) {
          callback({ status: 200 });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({
            status: 500,
            data: err?.message || "Some errors happened!",
          });
        }
      });
  };

//snap all provider
const allDefaultClientSub = [];
export const snapDefaultClient = (callback) => (dispatch) => {
  setDefaultClientAllSuccess(dispatch, null);
  const cRef = getRefs().client;
  const uid = auth?.currentUser?.uid;
  console.log({ uid });
  const c0 = where("reseller", "==", uid);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      setDefaultClientAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultClientSub.push(unsub);
};

export const unSnapDefaultClient = () => (dispatch) => {
  allDefaultClientSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultClientSub.length = 0;
};

//snap detail client for qc
const allDefaultClientDetail = [];
export const snapDefaultClientDetail =
  ({ clientId }, callback) =>
  (dispatch) => {
    setDefaultClientDetailSuccess(dispatch, null);
    const cRef = getRefs().client;
    const dRef = doc(cRef, clientId);
    const unsub = onSnapshot(dRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.data();
        setDefaultClientDetailSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });
    allDefaultClientDetail.push(unsub);
  };

export const unSnapDefaultClientDetail = () => (dispatch) => {
  allDefaultClientDetail.forEach((subscriber) => {
    subscriber();
  });
  allDefaultClientDetail.length = 0;
};

// handle search by email.
export const setSearchByEmail =
  ({ email }) =>
  (dispatch) => {
    setDefaultClientInfoSuccess(dispatch, null);
    const cRef = getRefs().user;
    const c0 = where("email", "==", email);
    const qRef = query(cRef, c0);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc.data());
        const detail = data?.length > 0 ? data[0] : null;
        setDefaultClientInfoSuccess(dispatch, detail);
      }
    });
  };

// search cloud
export const searchEmail =
  ({ email }, callback) =>
  (dispatch) => {
    setDefaultClientInfoSuccess(dispatch, null);
    const functions = getApiFunctions().reseller.searchUserEmail;
    const options = { email };

    console.log({ options });
    return functions(options)
      .then((res) => {
        const data = res?.data;
        console.log({ data });
        console.log({ res });
        console.log("success!");
        setDefaultClientInfoSuccess(dispatch, data);
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Invalid Error!" });
      });
  };

// handle search by email.
// export const setSearchById =
//   ({ id }, callback) =>
//   (dispatch) => {
//     setDefaultClientInfoSuccess(dispatch, null);
//     const cRef = getRefs().user;
//     const c0 = where("id", "==", id);
//     const qRef = query(cRef, c0);
//     console.log({ id });
//     getDocs(qRef)
//       .then((snapshot) => {
//         if (snapshot) {
//           const data = snapshot?.docs?.map((doc) => doc.data());
//           const detail = data?.length > 0 ? data[0] : null;
//           if (detail) {
//             setDefaultClientInfoSuccess(dispatch, detail);
//             callback && callback({ status: 200 });
//           } else {
//             callback && callback({ status: 500, data: "Không đúng mã QR" });
//           }
//         }
//       })
//       .catch((err) => {
//         console.log({ err });
//         callback &&
//           callback({ status: 500, data: "Không đúng mã QR" || err?.message });
//       });
//   };

// search cloud
export const setSearchById =
  ({ id }, callback) =>
  (dispatch) => {
    setDefaultClientInfoSuccess(dispatch, null);
    const functions = getApiFunctions().reseller.searchUserId;
    const options = { id };
    return functions(options)
      .then((res) => {
        const data = res?.data;
        console.log({ data });
        console.log({ res });
        console.log("success!");
        setDefaultClientInfoSuccess(dispatch, data);
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Invalid Error!" });
      });
  };

// ========= cloud function =========//
// ========= local function =========//
export const clearClientInfo = () => (dispatch) => {
  setDefaultClientInfoSuccess(dispatch, null);
};

export const setDefaultClientAll = (data, callback) => (dispatch) => {
  setDefaultClientAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultClientOpenAdd = (data, callback) => (dispatch) => {
  setDefaultClientOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultClientOpenEdit = (data, callback) => (dispatch) => {
  setDefaultClientOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultClientSelected = (data, callback) => (dispatch) => {
  setDefaultClientSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultClientSearch = (data, callback) => (dispatch) => {
  setDefaultClientSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultClientType = (data, callback) => (dispatch) => {
  setDefaultClientTypeSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultClientStep = (step, callback) => (dispatch) => {
  setDefaultClientStepSuccess(dispatch, step);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultClientInfoSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_INFO,
    payload: data,
  });
};

const setDefaultClientAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_ALL,
    payload: data,
  });
};

const setDefaultClientOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_OPEN_ADD,
    payload: data,
  });
};

const setDefaultClientOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_OPEN_EDIT,
    payload: data,
  });
};

const setDefaultClientSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_SELECTED,
    payload: data,
  });
};

const setDefaultClientSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_SEARCH,
    payload: data,
  });
};

const setDefaultClientTypeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_TYPE,
    payload: data,
  });
};

const setDefaultClientDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_DETAIL,
    payload: data,
  });
};

const setDefaultClientStepSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_CLIENT_STEP,
    payload: data,
  });
};
